import "./index.css";
import CommonButton from "../../components/commonButton";
import { Modal, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useToast } from "../../context/TostContext";
import withModal from "../../components/withModal";
import InputField from "../../components/form/InputField";
import LocationPinPicker from "./LocationPinPicker";

const AddStateModalInner = ({ onClose, rawTitle, onSubmit, defaultValue, isFileLevel: isFileLevelProp, isView }) => {
  const isFileLevel = isFileLevelProp !== undefined ? isFileLevelProp : rawTitle?.toLowerCase() === "file";
  const toast = useToast();  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [value, setValue] = useState(
    typeof defaultValue === "object" ? defaultValue?.name || "" : defaultValue || ""
  );
  const [title, setTitle] = useState(
    typeof defaultValue === "object" ? defaultValue?.title || "" : ""
  );
  const [file, setFile] = useState(null);
  // A location's map pin (see LocationPinPicker); files have none.
  const pinOf = (item) =>
    item && typeof item === "object" && item.latitude !== null && item.latitude !== undefined && item.longitude !== null && item.longitude !== undefined
      ? { latitude: Number(item.latitude), longitude: Number(item.longitude) }
      : null;
  const [pin, setPin] = useState(pinOf(defaultValue));

  useEffect(() => {
    setValue(typeof defaultValue === "object" ? defaultValue?.name || "" : defaultValue || "");
    setTitle(typeof defaultValue === "object" ? defaultValue?.title || "" : "");
    setPin(pinOf(defaultValue));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  const handleSubmit = async () => {
    if (isSubmitting) return;

    if (isFileLevel && (!title || !title.trim())) return;
    if (isFileLevel && !file && !defaultValue) return;
    if (!isFileLevel && (typeof value !== "string" || !value.trim())) return;

    try {
      setIsSubmitting(true);

      await onSubmit(
        isFileLevel
          ? { file, title: title.trim() }
          : {
              name: typeof value === "string" ? value.trim() : value,
              // null clears a pin; both sent together, as the API requires.
              latitude: pin ? pin.latitude : null,
              longitude: pin ? pin.longitude : null,
            }
      );

      setFile(null);
      setValue("");
      setTitle("");
      setPin(null);
      onClose();
    } catch (err) {
      console.error("Submit failed:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB

  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/png",
    "image/jpg",
    "image/webp",
    "application/pdf",
  ];

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!ALLOWED_TYPES.includes(selectedFile.type)) {
      toast.error("Only Image and PDF files are allowed");
      e.target.value = "";
      return;
    }

    if (selectedFile.size > MAX_FILE_SIZE) {
      toast.error("File size must be less than 50 MB");
      e.target.value = "";
      return;
    }

    setFile(selectedFile);

    // Auto-fill title from filename without extension ONLY on Create
    if (!defaultValue) {
      const lastDotIndex = selectedFile.name.lastIndexOf('.');
      const nameWithoutExt = lastDotIndex !== -1 
        ? selectedFile.name.substring(0, lastDotIndex) 
        : selectedFile.name;
      setTitle(nameWithoutExt);
    }
  };

  return (<>
    <Modal.Body>


      {isFileLevel ? (
        <>
          <Form.Group className="mb-3">
            <Form.Label>Attachment <span className="text-danger">*</span></Form.Label>

            <div className="tp-file-row">
              <div className="tp-file-choose">Choose File</div>

              <div className="tp-file-name">
                {file
                  ? file.name
                  : defaultValue
                    ? typeof defaultValue === "object"
                      ? defaultValue.file_name || defaultValue.name
                      : defaultValue
                    : "No file chosen"}
              </div>

              {file && (
                <div
                  className="tp-file-remove"
                  onClick={() => setFile(null)}
                >
                  ×
                </div>
              )}

              <input
                type="file"
                className="tp-file-input"
                accept="image/*,application/pdf"
                onChange={handleFileChange}
                disabled={isView}
              />
            </div>
          </Form.Group>

          <InputField
            label={{ name: "Title" }}
            required={true}
            input={{
              type: "text",
              value: title,
              placeholder: "Enter file title",
              onChange: (e) => setTitle(e.target.value),
              autoFocus: true,
              disabled: isView,
              className: "shadow-none mb-3",
            }}
          />
        </>
      ) : (
        <>
          <InputField
            label={{ name: rawTitle }}
            input={{
              type: "text",
              value: value,
              placeholder: `Enter ${rawTitle} name`,
              onChange: (e) => setValue(e.target.value),
              autoFocus: true,
              disabled: isView,
              className: "shadow-none",
            }}
          />
          <LocationPinPicker
            value={pin}
            onChange={setPin}
            disabled={isView}
            searchHint={typeof defaultValue === "object" ? defaultValue?.name || "" : ""}
          />
        </>
      )}


    </Modal.Body>

    {!isView && (
      <Modal.Footer className="justify-content-center">
        <CommonButton
          title={isSubmitting ? "Adding..." : defaultValue ? "Update" : "Add"}
          className="btn-primary fixed-size add-btn"
          onClick={handleSubmit}
          disabled={isSubmitting || (isFileLevel ? (!file && !defaultValue) || !title.trim() : (typeof value !== "string" || !value.trim()))}
        />
      </Modal.Footer>
    )}

  </>
  );
};

const AddStateModal = withModal(AddStateModalInner);
export default AddStateModal;
